import { Component, Injector } from '@angular/core';
import { SecurityDataService } from '../../../submodules/angular-common/security-data.service';
import { BaseView } from '../../../../app/submodules/angular-ui-common/base-view';
import { PageLayoutDataService } from '../../angular-common/page-layout-data.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseView {

  public userFirstName: string;

  constructor(
    protected _injector: Injector
    ) {
      super(_injector);
      this._injector.get(PageLayoutDataService).init({showBreadcrumbs:false})
  }

  ngOnInit(): void {
    this.userFirstName = this._injector.get(SecurityDataService).userProfile.name.split(' ')[0]
    this._injector.get(PageLayoutDataService).loading=false;
  }

}
